import { Button, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import HotelKycForm from "./HotelKycForm";
import { getActiveHotelId } from "../../Utils/Utils";
import { useEffect } from "react";
import axios from "axios";
import { springBaseUrl } from "../CalendarPage/constants/AmplitudeConstants";

const HotelKycCard = () => {
  const [showForm, setShowForm] = useState(false);
  const [showCard, setShowCard] = useState(false);

  const hotelId = getActiveHotelId();
  const token = localStorage.getItem("token");
  const checkKycStatus = async () => {
    try {
      const response = await axios.get(springBaseUrl + `core/api/v1/hotelKyc`, {
        headers: {
          Authorization: token,
        },
      });

      setShowCard(!response?.data?.kycComplete);
    } catch (error) {
      console.error("Error checking KYC status:", error);
    }
  };

  useEffect(() => {
    checkKycStatus();
  }, [hotelId, token]);
  return (
    <Stack
      sx={{
        width: "100%",
        height: "100%",
        display: showCard ? "block" : "none",
      }}
    >
      {!showForm && (
        <Stack sx={{ p: 2 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            As per the RBI and MCA guidelines, you are required to complete the
            KYC. It just takes 5 minutes.
          </Typography>
          <Typography variant="body2" mb={2}>
            Stayflexi is now PCI DSS Level 2 compliant, meaning we can store
            your data more securely. Please complete the KYC to stay compliant
            using our system.
          </Typography>
          <Button
            variant="contained"
            onClick={() => setShowForm(true)}
            fullWidth
          >
            Complete KYC Now
          </Button>
        </Stack>
      )}
      {showForm && (
        <HotelKycForm
          isFormComplete={!showCard}
          checkFormStatus={checkKycStatus}
        />
      )}
    </Stack>
  );
};

export default HotelKycCard;
